export default {
  name: 'personCusInfo',
  data () {
    return {
      labelPosition: 'right',
      formInline: {
        sysId: '',
        custName: '',
        custState: '',
        createTime: ''
      },
      stateData: [
        {
          id: 0,
          value: '停用'
        },
        {
          id: 1,
          value: '启用'
        }
      ],
      transferInfo: {
        person: '',
        primary: ''
      },
      openAccountInfo: {
        custNum: '',
        custName: '',
        supAccountData: []
      },
      openAccountDialog: false,
      transferDialog: false,
      contractDialog: false,
      rules: {
        person: [
          {
            required: true,
            message: '请变更责任人',
            trigger: ['blur', 'change']
          }
        ],
        primary: [
          {
            required: true,
            message: '请选择原责任人',
            trigger: ['blur', 'change']
          }
        ]
      },
      activeName: '',
      sysData: [],
      typeOneData: [],
      typeTwoData: [],
      source: [],
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      uploadFile: this.$API.fileUpload,
      contractInfo: {
        sysId: '',
        custName: '',
        numberContract: '',
        nameContract: '',
        paymentName: '',
        contractBalance: '',
        createTime: '',
        superContractor: '',
        companyContractor: '',
        contractFiles: [],
        extFieldList: []
      },
      contractDialog: false,
      tooltip: true,
      totalRows: 100,
      createTimeDesc: null,
      totalBalanceDesc: null,
      tableList: [],
      custArr: [], // 列表客户信息id存储,批量删除使用
      dialogFormVisible: false,
      distributionForm: {
        customerId: '',
        customerName: '',
        systemId: '',
        systemName: ''
      },
      abuNameData: [],
      distributionData: [],
      distributionProps: {
        label: 'productName',
        children: 'productDetails'
      },
      distributionChecked: []
    }
  },
  activated () {
    this.queryList()
  },
  mounted () {
    this.querySearchSel()
    if (this.$route.query.num) {
      this.page.num = Number(this.$route.query.num)
      this.page.size = Number(this.$route.query.size)
      this.page.sizeSmall = Number(this.$route.query.size)
    }
    // this.page = Object.assign({}, this.page)
    this.queryList()
  },
  methods: {
    /* 列表客户状态转换 */
    custState (row) {
      if (row.custState === '0') {
        return '停用'
      } else if (row.custState === '1') {
        return '启用'
      } else {
        return ''
      }
    },
    // 表格合同日期根据状态值设置颜色
    cellStyle (row, column, rowIndex, columnIndex) {
      if (row.column.label === '合同有效期') {
        if (row.row.expired === '0') {
          return ''
        } else if (row.row.expired === '2') {
          return 'color: orange'
        } else {
          return 'color: red'
        }
      }
    },
    success(response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        console.log(response.resData)
        let op = {}
        op.name = response.resData.fileName
        op.url = response.resData.url
        this.contractInfo.contractFiles.push(op)
      }
    },
    handleRemove(file, fileList) {
      // 删除图片
      let url = file.url
      for (let i = 0; i < this.contractInfo.contractFiles.length; i++) {
        if (this.contractInfo.contractFiles[i].url === url) {
          this.contractInfo.contractFiles.splice(i, 1)
        }
      }
    },
    /* 点击文件列表中已上传的文件时的钩子 */
    handlePreview(file) {
      /* 预览 TODO */
      console.log(file)
      let _width = window.outerWidth
      let _height = window.outerHeight
      window.open(
        file.url,
        '_blank',
        'width=' +
          _width +
          ', height = ' +
          _height +
          ', menubar = no,toolbar = no, status = no, scrollbars = yes'
      )
      // const userAgent = navigator.userAgent
      // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      //   alert('推荐谷歌进行文件预览')
      // } else {
      //   window.open(file.url) // blob格式地址
      // }
    },
    /* 上传前校验大小限制 */
    beforeAvatarUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 20
      /* if(!extension) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        });
      } */
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning'
        })
      }
      return extension && isLt2M
    },
    addExtField() {
      this.contractInfo.extFieldList.push({
        name: '',
        value: ''
      })
    },
    /* 删除扩展属性 */
    removeExtField(item) {
      var index = this.contractInfo.extFieldList.indexOf(item)
      if (index !== -1) {
        /* 对已存在的扩展属性删除push到另一个数组 */
        /* if (item.id) {
          item.isDelete = 1
          this.extFieldList2.push(item)
        } */
        this.contractInfo.extFieldList.splice(index, 1)
      }
    },
    /* 添加账户 */
    addSupAccount() {
      this.openAccountInfo.supAccountData.push({
        supAccountId: '',
        supAccountName: '',
        supAccountPwd: '',
        apikey: '',
        state: '',
        supId: ''
      })
    },
    /* 删除账户 */
    removeSupAccount(item) {
      var index = this.openAccountInfo.supAccountData.indexOf(item)
      if (index !== -1) {
        /* 对已存在的账户删除push到另一个数组 */
        if (item.supAccountId) {
          item.isDelete = 1
          this.supAccountData2.push(item)
        }
        this.openAccountInfo.supAccountData.splice(index, 1)
      }
    },
    closeOpenAccount () {},
    informationContract () {
      this.openAccountDialog = true
    },
    establishContract () {
      this.contractDialog = true
    },
    querySearchSel () {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      /* 查询客户来源 */
      this.$axios
        .get(this.$API.customerManagement.queryCustFromList)
        .then(function (r) {
          _self.source = r.data.resData
        })
        .catch(function (error) {})
      /* 查询客户类型1级 */
      this.$axios
      .get(this.$API.customerManagement.queryCustTypeFirst)
      .then(function (r) {
        _self.typeOneData = r.data.resData
      })
      .catch(function (error) {})
      /* 查询商务经理列表 */
      let type = {abuType: 2}
      this.$axios
        .get(this.$API.supplier.queryBusinessMangerList, {params: type})
        .then(function(r) {
          _self.abuNameData = r.data.resData.userList
        })
        .catch(function(error) {})
      /* 查询所属系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function (r) {
          _self.sysData = r.data.resData
        })
        .catch(function (error) {})
    },
    queryList () {
      /* 查询列表 */
      let sysIds = this.formInline.sysId
      let params = {
        endTime: this.formInline.createTime
          ? this.formInline.createTime[1]
          : '',
          startTime: this.formInline.createTime
          ? this.formInline.createTime[0]
          : '',
        custName: this.formInline.custName,
        custState: this.formInline.custState,
        sysIds: sysIds
          ? sysIds
          : [],
        pageNum: this.page.num,
        pageSize: this.page.sizeSmall
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryPersonCustInfoByPage, params)
        .then(function (r) {
          _self.tableList = r.data.resData.queryRes.resultList
          _self.totalRows = r.data.resData.queryRes.total
        })
        .catch(function (error) {})
    },
    establishContract () {
      this.contractDialog = true
    },
    closeContract () {},
    /* checkbox 选中时获取客户信息id */
    handleSelectionChange (val) {
      this.custArr = []
      if (val.length) {
        for (let v of val) {
          this.custArr.push(v.custId)
        }
      }
    },
    createTimeChange (column) {
      console.log(column.order)
      if (column.prop === 'createTime') {
        if (column.order === 'descending') {
          this.createTimeDesc = true
        } else if (column.order === 'ascending') {
          this.createTimeDesc = false
        }
      }
      if (column.prop === 'custAccountBalance') {
        if (column.order === 'descending') {
          this.totalBalanceDesc = true
        } else if (column.order === 'ascending') {
          this.totalBalanceDesc = false
        }
      }
      console.log(this.createTimeDesc)
      this.queryList()
    },
    transfer () { //  商务转移
      this.transferDialog = true
    },
    closeTransfer () {
      this.transferInfo.person = ''
      this.transferInfo.primary = ''
      this.$refs['transferInfo'].resetFields()
    },
    /* 跳转详情页 */
    detail (index, row) {
      this.$router.push({
        path: '/personDetail',
        query: {
          custId: row.custId,
          num: this.page.num,
          size: this.page.sizeSmall
        }
      })
    },
    transferSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.hisAbuId = _this.transferInfo.primary
          op.nowAbuId = _this.transferInfo.person
          _this.$axios({
            url: _this.$API.customerManagement.exchageAbuInfo,
            method: 'post',
            data: op
          }).then((response) => {
            _this.queryList()
            _this.$message.success('转移成功!')
            this.fileList = []
            _this.transferDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 批量删除客户信息 */
    handleDel () {
      if (!this.custArr.length) {
        this.$message.warning('请选择客户信息!')
        return
      }
      let params = {
        custIds: this.custArr,
        custCat: '1'
      }
      this.$confirm('确认删除客户信息?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let _self = this
          this.$axios
            .post(this.$API.customerManagement.deleteCustInfoByCustId, params)
            .then(function (r) {
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryList()
            })
            .catch(function (error) {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    changeOne (val) { // 根据客户类型一级查二级
      let params = {parentCustTypeId: val}
      let _this = this
      this.formInline.custTypeTwoId = ''
      this.$axios
        .get(this.$API.customerManagement.queryCustTypeByParentCustTypeId, {params: params})
        .then(function (r) {
          _this.typeTwoData = r.data.resData
        })
        .catch(function (error) {})
    },
    /* 切换状态 启用/禁用 */
    changeStatus (index, value) {
      if (value.custState === '1') {
        value.custState = '0'
        let params = {
          custId: value.custId,
          custState: 1
        }
        this.$confirm('确认是否修改客户状态为启用?', '启用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.customerManagement.updateCustStateById, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '启用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      } else {
        value.custState = '1'
        let params = {
          custId: value.custId,
          custState: 0
        }
        this.$confirm('确认是否修改客户状态为停用?', '停用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.customerManagement.updateCustStateById, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '停用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      }
    },
    /* 产品分配递归取出选中id */
    getDataChecked (data) {
      let checkedId = []
      for (let i in data) {
        try {
          if (!data[i].productDetails) {
            if (data[i].checked === true) {
              checkedId.push(data[i].productId)
              this.distributionChecked.push(data[i].productId)
            }
          } else {
            this.getDataChecked(data[i].productDetails)
          }
        } catch (e) {}
      }
      return checkedId
    },
    /* 产品分配 */
    handleDistribution (index, value) {
      this.dialogFormVisible = true
      let params = {
        customerId: value.custId
      }
      console.log('ss')
      let _self = this
      this.$axios
        .post(
          this.$API.customerManagement.getCustomerAbilitysGroupBySystem,
          params
        )
        .then(function (r) {
          let _data = r.data.resData
          _self.distributionForm.customerId = _data.customer.customerId
          _self.distributionForm.customerName = _data.customer.customerName
          _self.distributionForm.systemId = _data.products[0].systemInfo.systemId
          // _self.distributionForm.systemName = _data.products[0].systemInfo.systemName
          let data = _data.products
          /* 处理成树需要的相同格式 */
          for (let v of data) {
            let arr = v.groupProducts.concat()
            let obj = Object.assign({}, v.systemInfo)
            v.groupProducts = []
            v.productDetails = arr
            // v.productDetails.push(obj)
            v.productName = v.systemInfo.systemName
            v.checked = false
            v.productType = v.systemInfo.systemName
            for (let i = 0; i < v.productDetails.length; i++) {
              if (v.productDetails[i].productType) {
                v.productDetails[i].productId = 'sim_' + v.productDetails[i].productType
                v.productDetails[i].productName = v.productDetails[i].productType
                v.productDetails[i].checked = false
              }
            }
          }
          _self.distributionChecked = []
          _self.distributionData = data
          console.log(data)
          _self.getDataChecked(_self.distributionData)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /* 保存产品分配 */
    saveDistribution () {
      let _self = this
      let productIds = []
      let checkedNode = this.$refs.distributionTree.getCheckedNodes()
      if (checkedNode.length) {
        for (let i = 0; i < checkedNode.length; i++) {
          if (!checkedNode[i].productType) {
            productIds.push(checkedNode[i].productId)
          }
        }
      }
      console.log(productIds)
      let params = {
        customerId: this.distributionForm.customerId,
        productIds: productIds
      }
      this.$http
        .post(this.$API.customerManagement.allotProductIdsByCustomerId, params)
        .then(function (r) {
          _self.dialogFormVisible = false
          _self.$message({
            message: '保存成功',
            type: 'success'
          })
          _self.queryList()
        })
        .catch(function (error) {})
    },
    /* 关闭弹窗清空内容 */
    closeDialog (formName) {
      this.dialogFormVisible = false
      /* 关闭对话框清除验证和表单内容 */
      this.$refs[formName].resetFields()
      this.distributionForm.customerId = ''
      this.distributionForm.customerName = ''
      this.distributionForm.systemId = ''
      this.distributionForm.systemName = ''
      this.distributionData = []
      this.distributionChecked = []
    },
    /* 新增跳转路由 */
    handleAdd () {
      this.$router.push({
        path: '/addPersonCusInfo',
        query: {
          num: this.page.num,
          size: this.page.sizeSmall
        }
      })
    },
    /* 编辑跳转路由 */
    handleEdit (index, value) {
      this.$router.push({
        path: '/editPersonCusInfo',
        query: {
          custId: value.custId,
          num: this.page.num,
          size: this.page.sizeSmall
        }
      })
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/customerManagement/personCusInfo.js